import { asyncSelectWidgetObjectName } from '../../inputs/async-select/hooks/asyncSelectObjectName';
import { IButtonWidget } from './IButtonWidget';

export function getActionDataObjectName(widget: IButtonWidget, index: number) {
  return `${asyncSelectWidgetObjectName(widget.code)}-${index}`;
}
